import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@activebrands/core-web/libs/styletron';
import { setProductListLayout } from '@activebrands/core-web/state/productList/actions';

const Button = styled('button', {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1px',
    height: '16px',
    width: '16px',
});

const Cell = styled('div', {
    height: '100%',
    border: '1px solid var(--color-border)',
    borderRadius: '1px',
    transition: 'background var(--transition-fast)',
});

const GridButton = () => {
    const dispatch = useDispatch();
    const { layout } = useSelector(state => state.productList);
    const cellStyle = { background: layout === 'grid' ? 'var(--color-bg-inverted)' : 'transparent' };

    return (
        <Button type="button" onClick={() => dispatch(setProductListLayout('grid'))}>
            <Cell $style={cellStyle} />
            <Cell $style={cellStyle} />
            <Cell $style={cellStyle} />
            <Cell $style={cellStyle} />
        </Button>
    );
};

export default GridButton;
